import { render, staticRenderFns } from "./ChallengeBuilderTeamsTable.vue?vue&type=template&id=4ad93da2&lang=pug&"
import script from "./ChallengeBuilderTeamsTable.vue?vue&type=script&lang=js&"
export * from "./ChallengeBuilderTeamsTable.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeBuilderTeamsTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports